module.exports = __webpack_public_path__ + "assets/img/search_icon.f2e8d99e.svg";